module.exports = __webpack_public_path__ + "static/img/jtyh.53f4ad3e.png";